// Default name for a newly enrolled device, so the security screen shows
// something recognisable without asking the user to type anything.
export const suggestDeviceLabel = (userAgent: string): string => {
  const ua = userAgent.toLowerCase();
  if (ua.includes('iphone')) return 'iPhone';
  if (ua.includes('ipad')) return 'iPad';
  if (ua.includes('android')) return 'Android device';
  if (ua.includes('mac os') || ua.includes('macintosh')) return 'Mac';
  if (ua.includes('windows')) return 'Windows device';
  if (ua.includes('linux')) return 'Linux device';
  return 'This device';
};
